import React from 'react'
import { Badge } from 'react-bootstrap'
import useCurrentUser from '../../../hooks/use-current-user'
import useUser from '../../../hooks/use-user'
import utilities from '../../../utilities'

const User = ({
    user: userId
}) => {
    const { id: myId, isBusy: isLoadingMe } = useCurrentUser()
    const { user, isBusy: isLoadingUser } = useUser({ id: userId })

    if (isLoadingUser || isLoadingMe) {
        return null
    }

    const isMe = user.id === myId
    const label = isMe ? 'You' : utilities.getUserFullName(user, { grade: true, familyFirst: true })
    return (
        <div
            key={user.id}
            style={{
                display: 'inline-block',
                paddingLeft: '3px'
            }}
        >
            <Badge variant='secondary' >
                {label}
            </Badge>
        </div>
    )
}

export default User
